<template>
    <layout>
        <NotiificationDetail
            :moduleCode="moduleCode"
            :panelId="pageID"
            :readonly="readonlyFormItem"
            :value="form"
        />
    </layout>
</template>

<script>
	import GeneralMixin from '../../mixin'

  	export default {
  		mixins: [
            GeneralMixin
        ],
        components: {
            NotiificationDetail: () => import(/* webpackChunkName: "notification-history" */ '@/app/shared/components/notification/history/NotificationDetail'),
        },
    	data() {
      		return {
      			pageID: 'database_notifications',
        		form: {
				    id: null,
				    channel: null,
				    module: null,
                    data: {},
				    read_at: null,
				    updated_at: null,
				    created_at: null,
	            },
      		}
    	},
		computed: {
            readonlyFormItem() {
                return true;
            },

        },
        methods: {
            getLoadedItemData(res) {
                return res.data ? res.data : res;
            },
        },
  	}
</script>